import { PF_SERVER_URL } from "../Constants";
import { AWSAccessParams, EvidenceAttachment } from "../types/Interfaces";
import RemoteDataController from "./RemoteDataController";

export namespace AWSService {
  /**
   * Requests AWS STS (Security Token Service) to be created for the current user
   * @param token - Current user's JWT
   * @param contactID - The current user's Salesforce contact ID
   * @returns The generated credentials { accessKeyId: string; secretAccessKey: string; sessionToken: string; region: string; bucket: string; }
   */
  export async function generateSTSToken(token: string, contactID: string): Promise<AWSAccessParams> {
    return new Promise(async (resolve, reject) => {
      try {
        const url = PF_SERVER_URL + "/portfolio/AWS/generateSTSToken";

        const response: Response = await fetch(url, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            Token: token,
            ContactID: contactID,
          }),
        });

        if (response) {
          const json = await response.json();

          if (json.success) {
            resolve(json.body);
          } else {
            reject(json.message || json.error);
          }
        } else {
          reject("The server didn't respond");
        }
      } catch (error: any) {
        console.log(error);
        RemoteDataController.logError(error);
        reject("Failed to generate token");
      }
    });
  }

  export async function openAttachmentFromServer(
    token: string,
    contactID: string,
    accessParams: AWSAccessParams,
    evidenceContactID: string,
    evidenceID: string,
    attachment: EvidenceAttachment
  ): Promise<any> {
    return new Promise(async (resolve, reject) => {
      try {
        const url = PF_SERVER_URL + "/portfolio/AWS/getFileFromS3";

        const response: Response = await fetch(url, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            Token: token,
            ContactID: contactID,
            Bucket: accessParams.bucket,
            Key: `${evidenceContactID}/attachments/${evidenceID}/${attachment.name}`,
          }),
        });

        if (response) {
          const json = await response.json();

          if (json.success) {
            resolve(json.body);
          } else {
            reject(json.message || json.error);
          }
        } else {
          reject("The server didn't respond");
        }
      } catch (error: any) {
        console.log(error);
        RemoteDataController.logError(error);
        reject("An error has occurred");
      }
    });
  }
}
